import Footer from "../components/footer"
import Nav from "../components/nav"
import React, { useEffect } from "react"
import smoothscroll from "smoothscroll-polyfill"
import { Helmet } from "react-helmet"
import config from "../lib/config"

export default function Layout(props) {
  useEffect(() => {
    smoothscroll.polyfill()
  }, [])
  return (
    <>
      <Helmet>
        <meta name="description" content={config.siteDescription} />
      </Helmet>
      <div className="bg-white">
        <Nav onHomepage={props.homepage} />
        <main>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}
